import { apiClient } from 'src/utils/api-client';
import type { ApiClient } from 'src/utils/api-client';
import { AgreementDetailModel } from './models';

export function fetchHomeownerCountService(client: ApiClient = apiClient) {
  return client.get<number>('/homeowners/count');
}

export function fetchHomeownerAgreementsService(client: ApiClient = apiClient) {
  return client.get<AgreementDetailModel[]>('/homeowners/accounts/agreements');
}
